import Vue from 'vue';
import store from '@/store';
import App from '@/App.vue';
import router from './router';

// Plugins
import Notifications from 'vue-notification';
import BaseComponents from '@/plugins/baseComponents';
import BaseDirectives from './plugins/baseDirectives';
import BaseHttp from '@/plugins/baseHttp';
import BaseFormat from '@/plugins/baseFormat';
import BaseHelpers from '@/plugins/baseHelpers';
import Auth from '@/plugins/auth0Component';
import ErrorHandler from '@/plugins/errorHandler';
import Mixpanel from '@/plugins/mixpanelComponent';
import VueMask from 'di-vue-mask';
import VueSweetalert2 from 'vue-sweetalert2';
import vuelidate from 'vuelidate';
import VTooltip from 'v-tooltip';
import GoogleMaps from '@/plugins/googleMapsComponent';
import Amplitude from '@/plugins/amplitudeComponent';
import VueGtm from '@gtm-support/vue2-gtm';
import RemoteConfig from '@/plugins/envRemoteConfig';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import calendar from 'dayjs/plugin/calendar';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';

// Componentes CSS
import 'sweetalert2/dist/sweetalert2.min.css';
import '@/scss/styles.scss';

Vue.use(BaseComponents,);
Vue.use(BaseDirectives, store,);
Vue.use(BaseHttp,);
Vue.use(BaseFormat,);
Vue.use(BaseHelpers,);
Vue.use(VueMask,);
Vue.use(Auth,);
Vue.use(Mixpanel,);
Vue.use(ErrorHandler,);
Vue.use(Notifications,);
Vue.use(VueSweetalert2,);
Vue.use(vuelidate,);
Vue.use(VTooltip,);
Vue.use(GoogleMaps,);
Vue.use(Amplitude,);
Vue.use(RemoteConfig,);

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  vueRouter: router,
  loadScript: process.env.VUE_APP_GTM_ENABLED === 'true',
},);

dayjs.extend(customParseFormat,);
dayjs.extend(localizedFormat,);
dayjs.extend(calendar,);
dayjs.extend(utc,);
dayjs.extend(relativeTime,);
dayjs.extend(isSameOrAfter,);
dayjs.extend(isSameOrBefore,);
dayjs.extend(isoWeek,);
dayjs.locale('pt-br',);

// Directives
Vue.use(BaseDirectives, store,);

new Vue({
  render: (h,) => h(App,),
  store,
  router,
},).$mount('#app',);
